'use strict';
var __importDefault = this && this.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { 'default': mod };
};
Object.defineProperty(exports, '__esModule', { value: true });
const draft_js_1 = require('draft-js');
const EntityTypes_1 = __importDefault(require('./EntityTypes'));
exports.findNextEntity = contentState => {
    const blockMap = contentState.getBlockMap();
    let selection;
    let entityData;
    blockMap.forEach(contentBlock => {
        if (contentBlock) {
            contentBlock.findEntityRanges(character => {
                const entityKey = character.getEntity();
                if (entityKey !== null && !entityData) {
                    const data = contentState.getEntity(entityKey).getData();
                    if (EntityTypes_1.default[data.type]) {
                        entityData = data;
                        return true;
                    }
                }
                return false;
            }, (start, end) => {
                if (!selection) {
                    selection = draft_js_1.SelectionState.createEmpty(contentBlock.getKey()).merge({
                        anchorOffset: start,
                        focusOffset: end
                    });
                }
            });
        }
    });
    if (selection && entityData) {
        return {
            selection,
            entityData
        };
    }
    return undefined;
};    //# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmluZE5leHRFbnRpdHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZXZhbHVhdG9yL2ZpbmROZXh0RW50aXR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsdUNBQXdEO0FBRXhELHdFQUFnRDtBQUVuQyxRQUFBLGNBQWMsR0FBRyxDQUFDLFlBQTBCLEVBQUUsRUFBRTtJQUMzRCxNQUFNLFFBQVEsR0FBRyxZQUFZLENBQUMsV0FBVyxFQUFFLENBQUM7SUFDNUMsSUFBSSxTQUFxQyxDQUFDO0lBQzFDLElBQUksVUFBdUMsQ0FBQztJQUM1QyxRQUFRLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxFQUFFO1FBQzlCLElBQUksWUFBWSxFQUFFO1lBQ2hCLFlBQVksQ0FBQyxnQkFBZ0IsQ0FDM0IsU0FBUyxDQUFDLEVBQUU7Z0JBQ1YsTUFBTSxTQUFTLEdBQUcsU0FBUyxDQUFDLFNBQVMsRUFBRSxDQUFDO2dCQUN4QyxJQUFJLFNBQVMsS0FBSyxJQUFJLElBQUksQ0FBQyxVQUFVLEVBQUU7b0JBQ3JDLE1BQU0sSUFBSSxHQUFvQixZQUFZO3lCQUN2QyxTQUFTLENBQUMsU0FBUyxDQUFDO3lCQUNwQixPQUFPLEVBQUUsQ0FBQztvQkFDYixJQUFJLHFCQUFXLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxFQUFFO3dCQUMxQixVQUFVLEdBQUcsSUFBSSxDQUFDO3dCQUNsQixPQUFPLElBQUksQ0FBQztxQkFDYjtpQkFDRjtnQkFDRCxPQUFPLEtBQUssQ0FBQztZQUNmLENBQUMsRUFDRCxDQUFDLEtBQUssRUFBRSxHQUFHLEVBQUUsRUFBRTtnQkFDYixJQUFJLENBQUMsU0FBUyxFQUFFO29CQUNkLFNBQVMsR0FBRyx5QkFBYyxDQUFDLFdBQVcsQ0FBQyxZQUFZLENBQUMsTUFBTSxFQUFFLENBQUMsQ0FBQyxLQUFLLENBQ2pFO3dCQUNFLFlBQVksRUFBRSxLQUFLO3dCQUNuQixXQUFXLEVBQUUsR0FBRztxQkFDakIsQ0FDZ0IsQ0FBQztpQkFDckI7WUFDSCxDQUFDLENBQ0YsQ0FBQztTQUNIO0lBQ0gsQ0FBQyxDQUFDLENBQUM7SUFDSCxJQUFJLFNBQVMsSUFBSSxVQUFVLEVBQUU7UUFDM0IsT0FBTyxFQUFFLFNBQVMsRUFBRSxVQUFVLEVBQUUsQ0FBQztLQUNsQztJQUNELE9BQU8sU0FBUyxDQUFDO0FBQ25CLENBQUMsQ0FBQyJ9
